/* tslint:disable */
/* eslint-disable */
/**
 * MAPIIO API
 * API mapové aplikace Mapiio pro klientskou JavaScriptovou / React část.
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import globalAxios, { AxiosPromise, AxiosInstance } from 'axios';
import { Configuration } from '../configuration';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from '../base';
// @ts-ignore
import { DataGridFilterVO } from '../model';
// @ts-ignore
import { DataGridRowVO } from '../model';
// @ts-ignore
import * as Objs from './index'
// @ts-ignore
import { DataResponseVO, DataRequestVO, ExportRequestVO } from '@mc/data-filter-react';

/**
 * DataGridControllerApi - axios parameter creator
 * @export
 */
export const DataGridControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Export filtrovaných dat vrstvy do souboru.
         * @param {number} layerId 
         * @param {{ [key: string]: any; }} requestBody 
         * @param {string} [context] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        exportLayerDataByFilter: async (layerId: number, requestBody: DataRequestVO<{ [key: string]: any; }>, context?: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'layerId' is not null or undefined
            assertParamExists('exportLayerDataByFilter', 'layerId', layerId)
            // verify required parameter 'requestBody' is not null or undefined
            assertParamExists('exportLayerDataByFilter', 'requestBody', requestBody)
            const localVarPath = `/api/user-layers/layer/{layerId}/data/grid/export`
                .replace(`{${"layerId"}}`, encodeURIComponent(String(layerId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (context !== undefined) {
                localVarQueryParameter['context'] = context;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(requestBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Serverové filtrování, řazení, stránkování a seskupování dat vrstvy. Dynamické sloupce dle definice atributů vrstvy (MAPIO_Vrstva_Atribut).
         * @param {number} layerId 
         * @param {{ [key: string]: any; }} requestBody 
         * @param {string} [context] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findLayerDataByFilter: async (layerId: number, requestBody: DataRequestVO<{ [key: string]: any; }>, context?: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'layerId' is not null or undefined
            assertParamExists('findLayerDataByFilter', 'layerId', layerId)
            // verify required parameter 'requestBody' is not null or undefined
            assertParamExists('findLayerDataByFilter', 'requestBody', requestBody)
            const localVarPath = `/api/user-layers/layer/{layerId}/data/grid`
                .replace(`{${"layerId"}}`, encodeURIComponent(String(layerId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (context !== undefined) {
                localVarQueryParameter['context'] = context;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(requestBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * DataGridControllerApi - functional programming interface
 * @export
 */
export const DataGridControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = DataGridControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * Export filtrovaných dat vrstvy do souboru.
         * @param {number} layerId 
         * @param {{ [key: string]: any; }} requestBody 
         * @param {string} [context] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async exportLayerDataByFilter(layerId: number, requestBody: DataRequestVO<{ [key: string]: any; }>, context?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DataResponseVO<File>>> {

            const localVarAxiosArgs = await localVarAxiosParamCreator.exportLayerDataByFilter(layerId, requestBody, context, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Serverové filtrování, řazení, stránkování a seskupování dat vrstvy. Dynamické sloupce dle definice atributů vrstvy (MAPIO_Vrstva_Atribut).
         * @param {number} layerId 
         * @param {{ [key: string]: any; }} requestBody 
         * @param {string} [context] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async findLayerDataByFilter(layerId: number, requestBody: DataRequestVO<{ [key: string]: any; }>, context?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DataResponseVO<DataGridRowVO>>> {

            const localVarAxiosArgs = await localVarAxiosParamCreator.findLayerDataByFilter(layerId, requestBody, context, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * DataGridControllerApi - factory interface
 * @export
 */
export const DataGridControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = DataGridControllerApiFp(configuration)
    return {
        /**
         * Export filtrovaných dat vrstvy do souboru.
         * @param {number} layerId 
         * @param {{ [key: string]: any; }} requestBody 
         * @param {string} [context] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        exportLayerDataByFilter(layerId: number, requestBody: DataRequestVO<{ [key: string]: any; }>, context?: string, options?: any): AxiosPromise<DataResponseVO<File>> {
            return localVarFp.exportLayerDataByFilter(layerId, requestBody, context, options).then((request) => request(axios, basePath));
        },
        /**
         * Serverové filtrování, řazení, stránkování a seskupování dat vrstvy. Dynamické sloupce dle definice atributů vrstvy (MAPIO_Vrstva_Atribut).
         * @param {number} layerId 
         * @param {{ [key: string]: any; }} requestBody 
         * @param {string} [context] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findLayerDataByFilter(layerId: number, requestBody: DataRequestVO<{ [key: string]: any; }>, context?: string, options?: any): AxiosPromise<DataResponseVO<DataGridRowVO>> {
            return localVarFp.findLayerDataByFilter(layerId, requestBody, context, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * DataGridControllerApi - interface
 * @export
 * @interface DataGridControllerApi
 */
export interface DataGridControllerApiInterface {
    /**
     * Export filtrovaných dat vrstvy do souboru.
     * @param {number} layerId 
     * @param {{ [key: string]: any; }} requestBody 
     * @param {string} [context] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DataGridControllerApiInterface
     */
    exportLayerDataByFilter(layerId: number, requestBody: DataRequestVO<{ [key: string]: any; }>, context?: string, options?: any): AxiosPromise<DataResponseVO<File>>;

    /**
     * Serverové filtrování, řazení, stránkování a seskupování dat vrstvy. Dynamické sloupce dle definice atributů vrstvy (MAPIO_Vrstva_Atribut).
     * @param {number} layerId 
     * @param {{ [key: string]: any; }} requestBody 
     * @param {string} [context] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DataGridControllerApiInterface
     */
    findLayerDataByFilter(layerId: number, requestBody: DataRequestVO<{ [key: string]: any; }>, context?: string, options?: any): AxiosPromise<DataResponseVO<DataGridRowVO>>;

}

/**
 * DataGridControllerApi - object-oriented interface
 * @export
 * @class DataGridControllerApi
 * @extends {BaseAPI}
 */
export class DataGridControllerApi extends BaseAPI implements DataGridControllerApiInterface {
    /**
     * Export filtrovaných dat vrstvy do souboru.
     * @param {number} layerId 
     * @param {{ [key: string]: any; }} requestBody 
     * @param {string} [context] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DataGridControllerApi
     */
    public exportLayerDataByFilter(layerId: number, requestBody: DataRequestVO<{ [key: string]: any; }>, context?: string, options?: any) {
        return DataGridControllerApiFp(this.configuration).exportLayerDataByFilter(layerId, requestBody, context, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Serverové filtrování, řazení, stránkování a seskupování dat vrstvy. Dynamické sloupce dle definice atributů vrstvy (MAPIO_Vrstva_Atribut).
     * @param {number} layerId 
     * @param {{ [key: string]: any; }} requestBody 
     * @param {string} [context] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DataGridControllerApi
     */
    public findLayerDataByFilter(layerId: number, requestBody: DataRequestVO<{ [key: string]: any; }>, context?: string, options?: any) {
        return DataGridControllerApiFp(this.configuration).findLayerDataByFilter(layerId, requestBody, context, options).then((request) => request(this.axios, this.basePath));
    }
}
